import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import MultiSelect, { MultiSelectProps } from 'components/MultiSelect';

import { TravelDocumentSelect_data$key } from '__generated__/TravelDocumentSelect_data.graphql';

type Props = MultiSelectProps & {
  data: TravelDocumentSelect_data$key;
};

const TravelDocumentSelect = ({ data, ...rest }: Props) => {
  const { allTravelDocuments } = useFragment(
    graphql`
      fragment TravelDocumentSelect_data on Query {
        allTravelDocuments {
          id
          name
        }
      }
    `,
    data
  );

  return <MultiSelect {...rest} options={allTravelDocuments} />;
};

export default TravelDocumentSelect;
